export class DataTableDataHelper {

    offset: number;
    rowCount: number;
    filters: any;
    sortField: any;
    sortOrder: number;

    constructor() {
        this.offset = 0;
        this.rowCount = 0;
        this.filters = null;
        this.sortField = null;
        this.sortOrder = null;
    }
}
